import { JsonProperty } from '../../../models/utilities/json-property';
import { LocalTimeRead } from '../../../models/utilities/local-time-read';
import { PickupStatus } from '../enums/pickup-status';
import { OrderSummary } from '../shared/order-summary';

export class PickupRead {

    public id : number = 0;

    public dealerId : string = '';

    public dealerName : string = '';

    public serviceCenterId : string = '';

    public status : PickupStatus = PickupStatus.Open;

    @JsonProperty({ toClass : LocalTimeRead })
    public pickupTime : LocalTimeRead|undefined = undefined;

    public amount : number = 0.0;

    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date = new Date();

    @JsonProperty({ toType: 'datetime' })
    public lastModified : Date = new Date();

    public rowVersion : string = '';
    
    @JsonProperty({ toClass: OrderSummary, designType: 'array' })
    public orders : OrderSummary[] = [];

}
